import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { APP_NAME } from '../../config/constants';
interface WelcomeScreenProps {
  onLoadDemo: () => void;
}
export function WelcomeScreen({
  onLoadDemo
}: WelcomeScreenProps) {
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 flex items-center justify-center p-4 md:p-8" data-id="element-1150">
      <div className="w-full max-w-2xl" data-id="element-1151">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-1152">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-3xl shadow-2xl shadow-indigo-200 mb-6 transform rotate-3 hover:rotate-6 transition-transform" data-id="element-1153">
            <span className="text-white font-black text-4xl" data-id="element-1154">M</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-4 tracking-tight" data-id="element-1155">
            Welkom bij {APP_NAME}!
          </h1>

          <p className="text-xl md:text-2xl text-slate-600 font-medium max-w-2xl mx-auto mb-8" data-id="element-1156">
            Laad demo accounts om de app te verkennen
          </p>

          {/* Demo Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-1157">
            <Card className="inline-block p-8 bg-white border-2 border-amber-200 shadow-2xl" data-id="element-1158">
              <div className="flex flex-col items-center gap-6" data-id="element-1159">
                <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center shadow-md" data-id="element-1160">
                  <Sparkles className="w-8 h-8 text-amber-600" data-id="element-1161" />
                </div>

                <div className="text-center" data-id="element-1162">
                  <p className="font-black text-slate-900 mb-2 text-2xl" data-id="element-1163">
                    Demo Accounts
                  </p>
                  <p className="text-slate-600 mb-6 max-w-md" data-id="element-1164">
                    Ontdek de app met voorbeeldaccounts voor leerling, ouder,
                    docent en beheerder, compleet met realistische voortgang
                  </p>
                </div>

                <Button variant="primary" size="xxl" onClick={onLoadDemo} className="shadow-xl hover:shadow-2xl transition-shadow" data-id="element-1165">
                  <Sparkles className="w-5 h-5 mr-2" data-id="element-1166" />
                  Demo Accounts Laden
                </Button>
              </div>
            </Card>
          </motion.div>
        </motion.div>

        {/* Info Cards */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12" data-id="element-1167">
          <Card className="p-4 bg-indigo-50 border-indigo-200" data-id="element-1168">
            <div className="text-center" data-id="element-1169">
              <div className="text-3xl mb-2" data-id="element-1170">👨‍🎓</div>
              <p className="font-bold text-indigo-900 text-sm" data-id="element-1171">5 Leerlingen</p>
              <p className="text-xs text-indigo-700" data-id="element-1172">
                Djayden, Emma, Noah, Sophie &amp; Liam
              </p>
            </div>
          </Card>

          <Card className="p-4 bg-emerald-50 border-emerald-200" data-id="element-1173">
            <div className="text-center" data-id="element-1174">
              <div className="text-3xl mb-2" data-id="element-1175">👪</div>
              <p className="font-bold text-emerald-900 text-sm" data-id="element-1176">2 Ouders</p>
              <p className="text-xs text-emerald-700" data-id="element-1177">
                Mama &amp; Papa van Noah
              </p>
            </div>
          </Card>

          <Card className="p-4 bg-violet-50 border-violet-200" data-id="element-1178">
            <div className="text-center" data-id="element-1179">
              <div className="text-3xl mb-2" data-id="element-1180">👨‍🏫</div>
              <p className="font-bold text-violet-900 text-sm" data-id="element-1181">2 Docenten</p>
              <p className="text-xs text-violet-700" data-id="element-1182">
                Meester Jay &amp; Juf Lisa
              </p>
            </div>
          </Card>

          <Card className="p-4 bg-amber-50 border-amber-200" data-id="element-1183">
            <div className="text-center" data-id="element-1184">
              <div className="text-3xl mb-2" data-id="element-1185">🛡️</div>
              <p className="font-bold text-amber-900 text-sm" data-id="element-1186">Admin</p>
              <p className="text-xs text-amber-700" data-id="element-1187">Globaal beheer</p>
            </div>
          </Card>
        </motion.div>

        {/* Footer */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="text-center mt-12" data-id="element-1188">
          <p className="text-sm text-slate-500" data-id="element-1189">
            Alle gegevens worden lokaal opgeslagen in je browser
          </p>
        </motion.div>
      </div>
    </div>;
}